import React from 'react';
import styled from 'styled-components';
import snakeCase from 'lodash/snakeCase';

import { Switch } from 'antd';

import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Spacer from 'components/ui/Spacer';
import AntdForm from 'components/ui/Form';
import TextBox from 'components/ui/TextBox';

import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

import { ButtonPrimary } from '@yuhu-inc/yuhui';

const StyledFieldCardContainer = styled.div`
  border-top: 1.5px solid ${colors.PALE_GREY};
  width: 100%;
  margin-top: 15px;
  background-color: ${colors.WHITE};
  border-radius: 16px;
`;

const FullWidthText = styled(TextBox)`
  width: 100%;
`;

const StyledButton = styled(ButtonPrimary)`
  font-size: 42px !important;
  padding: 1px 10px 0 !important;
`;

const Cols = styled(Col)`
  margin-top: 30px;
`;

const ToggleSwitch = styled(Switch)`
  margin-left: 15px;
  border-radius: 100px !important;
`;

const AdditionalConditionalAnswer = ({
  conditionalAnswerType,
  values,
  additionalConditionalAnswer,
  setFieldValue,
  questionIndex,
  answerIndex,
  conditionalQuestionIndex,
  index,
  errors,
}) => {
  const errorCheck = errors && errors.conditional_answers && errors.conditional_answers[index];
  const hasToggleButton = additionalConditionalAnswer.hasOwnProperty('selected');
  const appendDeleteButton =
    (conditionalAnswerType === 'radio' && index > 1) ||
    (conditionalAnswerType !== 'radio' && index > 0);

  const deleteConditionalAnswer = () => {
    let newServiceAndUtilties = [...values.services_and_utilities];
    newServiceAndUtilties[questionIndex].answers[answerIndex].conditional_questions[
      conditionalQuestionIndex
    ].conditional_answers.splice(index, 1);
    setFieldValue('services_and_utilities', newServiceAndUtilties);
  };

  const handleConditionalAnswerValue = (val) => {
    let newConditionalAnswers = [
      ...values.services_and_utilities[questionIndex].answers[answerIndex].conditional_questions[
        conditionalQuestionIndex
      ].conditional_answers,
    ];
    let conditionalQuestionType =
      values.services_and_utilities[questionIndex].answers[answerIndex].conditional_questions[
        conditionalQuestionIndex
      ].type;

    if (conditionalQuestionType === 'checkbox') {
      newConditionalAnswers[index].selected = val;
      setFieldValue(
        `services_and_utilities[${questionIndex}].answers[${answerIndex}].conditional_questions[${conditionalQuestionIndex}].conditional_answers`,
        newConditionalAnswers
      );
    } else if (conditionalQuestionType === 'radio') {
      //loop through the answers array and set the toggle value of other indexes to false
      values.services_and_utilities[questionIndex].answers[answerIndex].conditional_questions[
        conditionalQuestionIndex
      ].conditional_answers.forEach((option, currentIndex) => {
        if (currentIndex === index && val === true) {
          newConditionalAnswers[currentIndex].selected = val;
        } else if (currentIndex !== index) {
          newConditionalAnswers[currentIndex].selected = false;
        }
      });
      setFieldValue(
        `services_and_utilities[${questionIndex}].answers[${answerIndex}].conditional_questions[${conditionalQuestionIndex}].conditional_answers`,
        newConditionalAnswers
      );
    }
  };

  return (
    <StyledFieldCardContainer>
      <Spacer mb={1}>
        <Row gutter={16}>
          <Col span={10}>
            <AntdForm.Item
              label={getTranslatedString('landlordPortal.documentTemplate.answerName')}
              validateStatus={errorCheck?.name && 'error'}
              help={errorCheck?.name}
            >
              <FullWidthText
                placeholder={getTranslatedString('landlordPortal.maintenance.placeHolder.enter')}
                size="large"
                value={additionalConditionalAnswer.name}
                onChange={(e) => {
                  setFieldValue(
                    `services_and_utilities[${questionIndex}].answers[${answerIndex}].conditional_questions[${conditionalQuestionIndex}].conditional_answers[${index}].name`,
                    e.target.value
                  );

                  if (hasToggleButton) {
                    setFieldValue(
                      `services_and_utilities[${questionIndex}].answers[${answerIndex}].conditional_questions[${conditionalQuestionIndex}].conditional_answers[${index}].value`,
                      snakeCase(e.target.value)
                    );
                  }
                }}
              />
            </AntdForm.Item>
          </Col>

          {hasToggleButton && (
            <Cols style={{ textAlign: 'center' }} span={8}>
              <span> Selected </span>
              <ToggleSwitch
                checked={additionalConditionalAnswer.selected}
                onChange={(val) => handleConditionalAnswerValue(val)}
              />
            </Cols>
          )}

          {appendDeleteButton && (
            <Cols span={4}>
              <StyledButton
                type="button"
                contentKey="landlordPortal.documentTemplate.deleteOption"
                onClick={() => {
                  deleteConditionalAnswer();
                }}
              />
            </Cols>
          )}
        </Row>
      </Spacer>
    </StyledFieldCardContainer>
  );
};

export default AdditionalConditionalAnswer;
